export default __webpack_public_path__ + "static/media/swoop-secure-shield-20px.794d0402.svg";